import Badge from "./IconBadge";

export {
    Badge as default,
};